import { render, staticRenderFns } from "./ProposalsLotItemsList.vue?vue&type=template&id=40ef9e2e&scoped=true&"
import script from "./ProposalsLotItemsList.vue?vue&type=script&lang=js&"
export * from "./ProposalsLotItemsList.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsLotItemsList.vue?vue&type=style&index=0&id=40ef9e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef9e2e",
  null
  
)

export default component.exports